import { addons } from "@storybook/manager-api";
import theme from "./theme";
import { toSentenceCase } from "../core/js/utilities/to-sentence-case.js";

addons.setConfig({
    // NOTE: Storybook has some shortcuts to focus menu items, number 1 and number 2 are some of those shortcuts
    // During the development of dropdown component we were able to catch this behavior
    // 1. Opening dropdown multi-select
    // 2. Checking an option
    // 3. Pressing key 1 or 2 should write that letter on the input and start filtering
    // 4. Instead of that it was focusing the storybook menu closing the dropdown
    enableShortcuts: false,
    theme,
    sidebar: {
        renderLabel: ({ name }) => toSentenceCase(name),
    },
});
